(function ($) {
  let $icon = $('.search-icon');

  $icon.click(() => {
    location.href = '/zoeken';
  });

})(jQuery, Drupal);
